import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box, Text } from '@chakra-ui/react';
import DropDown from 'components/forms/new/formikFormFields/DropDown';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import walkthroughIds from '../../../walkthroughIds';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';

const OCCCallingProfilesField = ({
    value,
    onChange,
    options,
    darkMode,
    error,
    showError,
    disableStackHeight,
}) => {
    const [isHovered, setIsHovered] = useState(false);

    const selectedIds = Array.isArray(value)
        ? value
              .map((val) => val?.id ?? val?.value)
              .filter((id) => id !== undefined && id !== null)
        : [];

    const handleSelectChange = (ids) => {
        const selectedOptions = (ids || [])
            .map((id) => options?.find((opt) => opt.id === id))
            .filter(Boolean);
        onChange(selectedOptions);
    };

    return (
        <FormControl
            sx={{ margin: '0 0 24px 0 !important', width: '100%' }}
            isInvalid={!!error && showError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                alignItems="flex-start"
                sx={
                    disableStackHeight
                        ? { width: '775px' }
                        : {
                              ...stackStyling(true),
                              height: 'auto',
                              minHeight: '75px',
                          }
                }
                width="100%">
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Calling Profiles{' '}
                        <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Select one or more calling profiles for this service.
                    </Text>
                </Box>
                <Box flex="1" minWidth="450px">
                    <DropDown
                        data={options}
                        shownValue="name"
                        isMulti
                        multiValue={selectedIds}
                        width="100%"
                        darkMode={darkMode}
                        placeholder="- Select Calling Profiles -"
                        handleSelectChange={handleSelectChange}
                        name="callingProfiles"
                        walkthroughId={
                            walkthroughIds.serviceProfiles
                                ?.ufCallingProfilesSelect
                        }
                    />
                    {showError && (
                        <Text
                            color="red.500"
                            fontSize="xs"
                            mt={1}
                            textAlign="right">
                            {error}
                        </Text>
                    )}
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Select one or more calling profiles for this service."
                        ariaLabel="operator-connect-calling-profiles-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default OCCCallingProfilesField;
